
import { Component, Prop, Vue } from 'vue-property-decorator'
import { SimpleBreadcrumbWithCount } from '~/components/search/types'

@Component
export default class BreadcrumbsGenerator extends Vue {
  @Prop({ required: true })
    breadcrumbs: SimpleBreadcrumbWithCount[]

  @Prop({ default: true, type: Boolean })
    withCounts: boolean

  get query() {
    const query = { ...this.$route.query }
    // remove type from query if it's an array with only one element
    // as single type/category is already in url
    if (Array.isArray(query.type) && query.type.length === 1) {
      delete query.type
    }
    return query
  }

  isCityLevel(breadcrumb: SimpleBreadcrumbWithCount) {
    return breadcrumb.hierarchyLevel === 3
  }
}
